import { Typography } from '@breetometer/components';
import { TrashIcon } from 'BreetAssets';
import { Prompt } from 'BreetComponents';
import { handleApiError } from 'BreetHelpers';
import {
	closeModal,
	selectDeveloperIntegration,
	selectModals,
	useAppDispatch,
	useAppSelector,
	useSetIpAddressMutation,
} from 'BreetRedux';
import { useCallback } from 'react';

export const DialogDeleteDeveloperIpAddress = () => {
	const developerIntegrationData = useAppSelector(selectDeveloperIntegration);

	const [setIpAddressMutation, { isLoading }] = useSetIpAddressMutation();

	const dispatch = useAppDispatch();

	const modals = useAppSelector(selectModals);

	const modal = modals.find((modalItem) => modalItem.id === 'deleteIpAddress');

	const ipAddressData = modal?.metadata as { ipAddress?: string } | undefined;

	const closeDeleteModal = useCallback(() => {
		dispatch(closeModal('deleteIpAddress'));
	}, [dispatch]);

	const deleteIpAddress = useCallback(() => {
		if (ipAddressData?.ipAddress) {
			const ipAddresses = developerIntegrationData.data?.data?.ipAddresses ?? [];

			const modifiedIpAddresses = ipAddresses.filter((i) => i !== ipAddressData.ipAddress);

			setIpAddressMutation({ ipAddresses: modifiedIpAddresses }).unwrap().then(closeDeleteModal).catch(handleApiError);
		}
	}, [ipAddressData?.ipAddress, developerIntegrationData.data?.data?.ipAddresses, setIpAddressMutation, closeDeleteModal]);

	const title = 'Delete IP Address';

	const description = 'Are you sure you want to delete this IP Address?';

	return (
		<Prompt
			title={title}
			description={description}
			content={<Typography className='font-sm selected letter-spacing'>{ipAddressData?.ipAddress}</Typography>}
			cancelBtnText='Cancel'
			icon={
				<TrashIcon
					variant='secondary-outline'
					className='svg-dark svg-dark-outline svg-dark-fill'
				/>
			}
			isLoading={isLoading}
			onCancel={closeDeleteModal}
			onProceed={deleteIpAddress}
			proceedBtnText='Delete'
		/>
	);
};
